@let editable = isEditable();
@let editing = isEditing();
@let noItem = hasNoItem();
@let noBasket = hasNoBasket();
@let noFooter = hideFooter();

<div class="z-10 overflow-hidden size-full flex justify-stretch items-stretch">

  <!-- TODO 🪛 check if highlightMeScene directive still works -->
  <div class="wizard-content-wrapper
              z-10 overflow-hidden
              size-full
              grid
              gap-y-2
              grid-cols-[minmax(0,1fr)]
              grid-rows-[max-content_1fr_3rem]
              [&.no-item]:grid-rows-[max-content_1fr_0rem]
              [&.no-basket]:grid-rows-[0rem_1fr_0rem]
              [&.no-item.no-basket]:grid-rows-[0rem_1fr_0rem]
              [&.no-footer]:grid-rows-[max-content_1fr_0rem]
              [&.options-displayed.no-footer]:grid-rows-[max-content_1fr_0rem]
              justify-stretch
              items-stretch
              [&.no-item]:justify-center
              bg-white
              transition-all"
    highlightMeScene
    [class.no-footer]="noFooter"
    [class.no-basket]="noBasket"
    [class.no-item]="noItem"
    [class.editing]="editing"
    [class.options-displayed]="isOptionsPanelDisplayed()">

    <mir-wizard-panel-controls
      (optionsPanelStateChange)="handleOptionsPanelStateChange($event)">
    </mir-wizard-panel-controls>

    <section class="group/Main size-full z-30 block overflow-hidden">
      @if (noBasket) {
        <div class="z-20 size-full grid place-items-center">
          <button mirButton flat medium accent
              (click)="handleNewBasket($event)">
            <MirIcon>auto_awesome</MirIcon>
            {{'Wizard.Panel.UI.Labels.New' | translate}}
          </button>
        </div>
      } @else {
        <mir-wizard-panel-list
          [editable]="editable">
        </mir-wizard-panel-list>
      }
    </section>

    <section class="z-40 size-full
                    flex items-center justify-center
                    shadow-inner border-top
                    ring-1 ring-gray-600 ring-offset-black ring-opacity-20">
      @if (isResultDisplayed()) {
        <div class="size-full inline-flex items-center gap-x-2 justify-center text-primary">
          @if (updated()) {
            <button mirButton danger cover
                (click)="handleRefreshResults($event)">
              <MirIcon>refresh</MirIcon>
              {{'Wizard.Panel.UI.Labels.RefreshResults' | translate}}
            </button>
          } @else {
            <MirIcon>auto_awesome</MirIcon>
            {{'Wizard.Panel.UI.Labels.BasketResults' | translate}}
          }
        </div>
      } @else {
        <button mirButton accent cover
            class="rounded-none"
            [disabled]="hasNoItem()"
            (click)="handleDisplayResults($event)">
          <MirIcon>auto_awesome</MirIcon>
          {{'Wizard.Panel.UI.Labels.DisplayResults' | translate}}
        </button>
      }
    </section>
  </div>
</div>
